var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55906 18.8817C1.72812 18.9671 1.91857 19.0076 2.11009 18.9988C2.30161 18.99 2.487 18.9323 2.64647 18.8317L15.3524 10.8319C15.4974 10.7406 15.6163 10.6169 15.6985 10.4717C15.7807 10.3266 15.8238 10.1645 15.8238 9.99993C15.8238 9.83532 15.7807 9.67326 15.6985 9.52812C15.6163 9.38299 15.4974 9.25927 15.3524 9.16795L2.64647 1.16815C2.48701 1.06767 2.30166 1.00996 2.11019 1.00118C1.91873 0.992394 1.72833 1.03287 1.55931 1.11827C1.39029 1.20368 1.24899 1.33082 1.15049 1.48613C1.05198 1.64144 0.999971 1.81909 1 2.00013V17.9997C0.999923 18.1808 1.05189 18.3584 1.15034 18.5138C1.2488 18.6691 1.39007 18.7963 1.55906 18.8817ZM3.11765 3.86908L12.8588 9.99993L3.11765 16.1308V3.86908ZM16.8824 15.9998V4.00008C16.8824 3.73487 16.9939 3.48052 17.1925 3.29299C17.391 3.10546 17.6604 3.0001 17.9412 3.0001C18.222 3.0001 18.4913 3.10546 18.6899 3.29299C18.8884 3.48052 19 3.73487 19 4.00008V15.9998C19 16.265 18.8884 16.5193 18.6899 16.7069C18.4913 16.8944 18.222 16.9998 17.9412 16.9998C17.6604 16.9998 17.391 16.8944 17.1925 16.7069C16.9939 16.5193 16.8824 16.265 16.8824 15.9998Z",
    fill: "#353434",
    stroke: "#F6F6F6",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.d528a208adc05ce0eb05a54e323785d8.svg";
export { ForwardRef as ReactComponent };